import React from "react";
import "./Sections.scss";

function QA9() {
  return (
    <section className="interview">
      <div className="interview__interview">
        <p className="interview__interview__title">
          What message do you want people to take away from the Love in Verona
          collection?
        </p>
        <p className="interview__interview__copy">
          I sincerely hope Love in Verona represents true love. I sincerely hope
          that it lasts forever. And I sincerely hope that I create happiness. I
          hope that it can be a forever piece—many things go out of fashion, but
          it's the kind of jewelry you can pass down to your granddaughter.
        </p>
      </div>
    </section>
  );
}

export default QA9;
